import React, { Component, createRef } from 'react'
import { Image } from '@sitecore-jss/sitecore-jss-react';

import { initAoxInViewport, destroyAoxInViewport } from '../../utilities/FrontFunctions/AoxInViewportClass'
import { throttle, isMobile, AoxCarouselPrevArrow,	AoxCarouselNextArrow } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import Slider from "react-slick"

import '../../../src/assets/css/0010_sections/0520_section_nouveautes.css'
import '../../../src/assets/css/0020_objects/1020_obj_banner.css'
import '../../../src/assets/css/0020_objects/1030_obj_push.css'


class SectionNouveautes2026 extends Component {
    constructor(props) {
        super(props)

        this.sectionRef = createRef()
        this.viewportObserver = null
        
        this.state = {
            isMobile: isMobile(),
            bannerCarousel: [
                {
                    idBanner:1,
                    is_Text: true,
                    ribbon: "NOUVEAU",
                    title: "Pharmacies pour le futur",
                    description: "Participez dès aujourd’hui à cette formation pour développer votre expertise RSE et découvrir des actions concrètes pour une pharmacie plus durable et engagée.",
                    visuel: "images/v_banner-services-pa1.jpg",
                    link: "/#",
                    classBanner: "var_center has_text-white",
                    has_CTA: true,
                    cta: {
                        text: "Découvrir",
                        link: "/#"
                    }
                },
                {
                    idBanner:2,
                    is_Text: false,
                    ribbon: "",
                    title: "",
                    description: "",
                    visuel: "images/v_banner-services-pa2.jpg",
                    link: "/HomeMarque",
                    classBanner: "",
                    has_CTA: false,
                    cta: {
                        text: "",
                        link: ""
                    }
                },
                {
                    idBanner:3,
                    is_Text: true,
                    ribbon: "",
                    title: "Lorem ipsum dolor sit amet",
                    description: "Participez dès aujourd’hui à cette formation pour développer votre expertise RSE et découvrir des actions concrètes pour une pharmacie plus durable et engagée.",
                    visuel: "images/v_push-cercle_elite-02.jpg",
                    link: "/#",
                    classBanner: "var_left has_text-black",
                    has_CTA: true,
                    cta: {
                        text: "Je me forme",
                        link: "/#"
                    }
                }
            ]
        }
        this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
        this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
    }
    handleWindowResizeMainHeader() {
        this.setState({
            isMobile: isMobile()
        })
    }
    componentDidMount() {
        window.addEventListener('resize', this.throttleWindowResizeMainHeader)
        this.viewportObserver = initAoxInViewport({
            element: this.sectionRef.current,
            threshold: 0.2,
            rootMargin: '0px 0px -80px 0px',
            once: true,
            onEnter: () => {
                this.setState({ isVisible: true })
            }
        })
        
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
        destroyAoxInViewport(this.viewportObserver)
    }
    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}


    render() {
        const { isVisible } = this.state
        const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carrousel",
            centerMode: false,
			infinite: false,
			slidesToShow: 2,
			swipeToSlide: true,
            variableWidth: true,
			onSwipe: this.onSwipe.bind(this),
            dots: true,
            dotsClass: "nav",
            appendDots: dots => (
                <div className="nav" >
                    <ul role="tablist"> {dots} </ul>
                </div>
            ),
            arrows: true,
            prevArrow: <AoxCarouselPrevArrow />,
	        nextArrow: <AoxCarouselNextArrow />,
            speed: 750,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        className: "obj_carrousel carrousel_full",
                        slidesToShow: 1,
                    }
                }
            ]
        };

   		const {scDatas} = this.props;

        return (
            <section ref={this.sectionRef} className={`obj_section section_nouveautes ${isVisible ? 'is-visible' : ''}`}>
				 
				<div className='ctn_section-header'>
					<div className="obj_text">
						<div className="ctn_text-header animation_reveal-item animation_reveal--fade-up animation_delay-1">
							<h2 className="t_title">Nos dernières nouveautés</h2>
						</div>
					</div>
				</div>
               
                <div className="ctn_carrousel">
				    { scDatas.Banners?.length!==0 && 
                        <Slider {...settings} ref={sliderRef}>
                            {scDatas.Banners.children.map((BannerItem, index) => (
                                <div key={index} className="item">
                                    <div className={`obj_banner banner--small animation_reveal-item animation_reveal--fade-up animation_delay-${index + 1}`}>
								        {BannerItem.bannerLink.jss.value.href!=="" ? 
                                            <a href={BannerItem.bannerLink.jss.value.href}>
                                                <div className='ctn_banner'></div>
                                                <div className='ctn_background'>
                                                    <div className='obj_image image_cover'>
                                                        <picture className='ctn_image fade-in'>
                                                            <source srcSet={BannerItem.bannerImageMobile.jss.value?.src} media="(max-width:767px)" />
                                                            <Image field={BannerItem.bannerImage.jss}></Image>
                                                        </picture>
                                                    </div>
                                                </div>
                                            </a>
                                        :
                                            <>
                                                <div className='ctn_banner'></div>
                                                <div className='ctn_background'>
                                                    <div className='obj_image image_cover'>
                                                        <picture className='ctn_image fade-in'>
                                                            <source srcSet={BannerItem.bannerImageMobile.jss.value?.src} media="(max-width:767px)" />
                                                            <Image field={BannerItem.bannerImage.jss}></Image>
                                                        </picture>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    }
                </div>

			</section>
        )
    }
}

export default SectionNouveautes2026